import {Trans, useTranslation, withTranslation} from "react-i18next";
import React from "react";

import {Field, Form, withFormik} from 'formik';
import * as Yup from 'yup'
import {TextField} from 'formik-material-ui';

import Box from "@material-ui/core/Box";
import {useAuth} from "../../hooks/auth";
import LoadingButton from "../../../Common/LoadingButton";
import {makeStyles} from "@material-ui/core/styles";

const { useEffect } = React;

const useStyles = makeStyles(theme => ({
  margin: {
    marginBottom: theme.spacing(1)
  },
  postalCodeCity: {
    display: 'flex',
  },
  postalCode: {
    flexBasis: '40%',
    marginRight: theme.spacing(1)
  }
}))

const TextFieldWithMargin = (props) => {
  const classes = useStyles();
  return <TextField className={classes.margin} {...props} />
}

export default (props) => {
  const { signUp } = useAuth();
  return <FormWithFormik signUp={signUp} {...props} />
}

const SignUpForm = ({isValid, isSubmitting}) => {
  const {t} = useTranslation();

  const classes = useStyles();
  return (
    <Form>
      <Field component={TextFieldWithMargin} name='name' label={t('Your name')}  fullWidth/>
      <Field component={TextFieldWithMargin} name='mobile' label={t("Mobile number")} fullWidth />
      <Field component={TextFieldWithMargin} name='email' label={t('Email address')}  fullWidth />
      <Field component={TextFieldWithMargin} name='password' type='password' label={t('Password')}  fullWidth />
      <Field component={TextFieldWithMargin} name='address' label={t('Address')}  fullWidth />

      <div className={classes.postalCodeCity}>
        <Field className={classes.postalCode} component={TextFieldWithMargin} name='zipcode' label={t('Postal code')}  fullWidth />
        <Field component={TextFieldWithMargin} name='city' label={t('City')}  fullWidth />
      </div>

      <Box mt={2} mb={2}>
        <LoadingButton type='submit' variant="contained" color="primary" fullWidth disabled={!isValid} isLoading={isSubmitting}>
          <Trans>Register</Trans>
        </LoadingButton>
      </Box>
    </Form>
  )
}

const validationSchema = ({t}) => {
  return Yup.object().shape({
    name: Yup.string()
      .required(t('Name is required')),
    mobile: Yup.string()
      .required(t('Mobile number is required')),
    email: Yup.string()
      .required(t('Email address is required')),
    password: Yup.string()
      .required(t('Password is required')),
  })
}

const mapPropsToValues = ({customerInfo}) => {
  return {
    name: customerInfo && customerInfo.name || '',
    mobile: customerInfo && customerInfo.mobile || '',
    email: customerInfo && customerInfo.email || '',
  }
}

const FormWithFormik = withTranslation()(withFormik({
  isInitialValid: props => validationSchema(props).isValidSync(mapPropsToValues(props)),
  mapPropsToValues,
  validationSchema,
  handleSubmit(values, {props, setSubmitting, setErrors} )  {
    console.log('Props', props);
    const {signUp, onSignUpSuccess} = props;

    setSubmitting(true);
    signUp(values)
      .then(() => {
        onSignUpSuccess();
      })
      .catch( (e, e2) => {
        console.log('Create user', e, e2);
        setErrors(e.data || {email: e.error})
      })
      .finally(() => {
        setSubmitting(false);
      })

    //props.onSubmit(values)
  },
})(SignUpForm));
